import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <p>© 2026 Martin Donev. All rights reserved.</p>
    </footer>
  );
}

export default Footer;